/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

export type InsuranceCoverage =
  | AccidentCoverage
  | AkaChildCoverage
  | AkaCriticalIllnessCoverage
  | AkaFamilyAccidentCoverage
  | AkaGroupLifeCoverage
  | AkaHouseContentsCoverage
  | AkaStudentCoverage
  | AkaTravelCoverage
  | AnimalCoverage
  | AuroraChildCompleteCoverage
  | AuroraChildCoverage
  | AuroraCriticalIllnessCoverage
  | AuroraDisabilityAndAccidentCoverage
  | AuroraDisabilityInterestCoverage
  | AuroraDisabilityTotalCoverage
  | BoatCoverage
  | CabinCoverage
  | CabinContentsCoverage
  | CarCoverage
  | CaravanCoverage
  | ChildCoverage
  | CriticalIllnessCoverage
  | DeathCoverage
  | ElectricScooterCoverage
  | HouseCoverage
  | HouseContentsCoverage
  | MopedCoverage
  | VehicleCoverage
  | NewChildCoverage
  | PregnantAndNewbornCoverage
  | RentalCoverage
  | TractorCoverage
  | TrailerCoverage
  | TravelCoverage
  | ValuablesCoverage
  | VeteranCoverage;

export enum AccidentCoverage {
  DISABLEMENT = 'Medisinsk invaliditet',
  DEATH = 'Død',
  DISABLEMENT_FULL_TIME = 'Medisinsk invaliditet, heltid',
  DEATH_FULL_TIME = 'Død, heltid',
  DEATH_AND_DISABLEMENT = 'Død og medisinsk invaliditet',
}

export enum AkaChildCoverage {
  STANDARD = 'A+ Barn Standard',
  INCAPACITY_OF_WORK = 'A+ Barn Uførekapital',
  INCAPACITY_PENSION = 'A+ Barn Uførepensjon',
}

export enum AkaCriticalIllnessCoverage {
  AKA_CRITICAL_ILLNESS = 'A+ Kritisk Sykdom',
  CO_INSURED = 'A+ Kritisk Sykdom medforsikret',
  MEMBER_AND_CO_INSURED = 'A+ Kritisk Sykdome med medforsinkret', // Typo is in insurance-rest as well
}

export enum AkaFamilyAccidentCoverage {
  DEATH = 'A+ Familieulykke død',
  MEDICAL_DISABILITY = 'A+ Medisinsk invaliditet',
  DEATH_AND_DISABILITY = 'A+ Familieulykke død og A+ Medisinsk invaliditet',
  DEATH_AND_DISABILITY_AND_PROFESSIONAL_DISABILITY = 'A+ Familieulykke død, A+ Medisinsk invaliditet med faginvaliditet',
  MEDICAL_DISABILITY_WITH_PROFESSIONAL_DISABILITY = 'A+ Medisinsk invaliditet med faginvaliditet',
}

export enum AkaGroupLifeCoverage {
  INSURED_DEATH = 'A+ Dødsfall',
  INSURED_INCAPACITY_OF_WORK = 'A+ Uførekapital',
  INSURED_TIME_LIMITED_DISABILITY_INTEREST = 'A+ Tidsbegrenset uførerente',
  CO_INSURED_DEATH = 'A+ Dødsfall medforsikret',
  CO_INSURED_INCAPACITY_OF_WORK = 'A+ Uførekapital medforsikret',
  CO_INSURED_TIME_LIMITED_DISABILITY_INTEREST = 'A+ Tidsbegrenset uførerente medforsikret',
}

export enum AkaHouseContentsCoverage {
  STANDARD = 'A+ Innbo',
  NATURE = 'A+ Naturskade',
}

export enum AkaStudentCoverage {
  TRAVEL_SUPER = 'A+ Student Super Reise',
  TRAVEL_SUPER_NORDIC = 'A+ Student Reise Super Studerer Norden',
  TRAVEL_SUPER_EUROPE = 'A+ Student Reise Super Studerer Utenlands',
  TRAVEL_SUPER_AUSTRALIA = 'A+ Student Reise Super Studerer Utenlands',
  TRAVEL_SUPER_USA = 'A+ Student Reise Super Studerer Utenlands',
  TRAVEL_SUPER_OTHER_COUNTRIES = 'A+ Student Reise Super Studerer Utenlands',
}

export enum AkaTravelCoverage {
  FAMILY = 'A+ Super Familiedekning',
  INSURED_ONLY = 'A+ Super Enkeltpersonsdekning',
}

export enum AnimalCoverage {
  DOG_DEATH_AND_INSURANCE_VALUE = 'Død og bruksverdi',
  DOG_VET = 'Veterinærutgifter, hund',
  CAT_DEATH = 'Død, katt',
  CAT_VET = 'Veterinærutgifter, cat',
}

export enum AuroraChildCoverage {
  CHILD_ACCIDENT = 'Barneulykke',
  CHILD_AND_YOUTH = 'Barne- og ungdomsforsikring',
  YOUTH_PLUSS = 'Ungdom Pluss',
}

export enum AuroraChildCompleteCoverage {
  COLLECTIVE = 'Barn samledekning BVMI',
  DISABILITY_CAPITAL = 'Barn uførekapital BUK',
  DISABILITY_INTEREST = 'Barn uførerente BUR',
  ADMIN = 'Admindekning barn',
}

export enum AuroraCriticalIllnessCoverage {
  CRITICAL_ILLNESS = 'Alvorlig Sykdom',
  SMOKER = 'Alvorlig sykdom med røyk',
  TRIPLE = 'Alvorlig sykdom trippel',
  ADMIN = 'Admindekning',
  ADMIN_NO_PIECE_RATE = 'Admindekning - uten stykk',
}

export enum AuroraDisabilityAndAccidentCoverage {
  DISABILITY_MAN = 'Uføreforsikring - mann',
  DISABILITY_WOMAN = 'Uføreforsikring - kvinne',
  DISABILITY_ADMIN = 'Admindekning - uføre',
  DISABILITY_ADMIN_NO_PIECE_RATE = 'Admindekning - uføre - uten stykk',
  ACCIDENT = 'Ulykkesforsikring',
  ACCIDENT_ADMIN = 'Admindekning - ulykke',
  ACCIDENT_ADMIN_NO_PIECE_RATE = 'Admindekning - ulykke - uten stykk',
}

export enum AuroraDisabilityInterestCoverage {
  URKN = 'Uførerente URKN',
  URKN_SMOKER = 'Uførerente URKN med røyk',
  URKN_3MONTHS = 'Uførerente URKN, 3mnd',
  URKN_SMOKER_KARENS_3_MONTHS = 'Uførerente URKN med røyk, 3mnd karens',
  URKN_62 = 'Uførerente URKN-62k',
  URKN_62_SMOKER = 'Uførerente URKN-62 med røyk',
  URKN_62_3MONTHS = 'Uførerente URKN-62, 3mnd',
  URKN_62_SMOKER_KARENS_3_MONTHS = 'Uførerente URKN-62 med røyk, 3mnd karens',
  URKN_60 = 'Uførerente URKN-60',
  URKN_60_SMOKER = 'Uførerente URKN-60 med røyk',
  URKN_60_3MONTHS = 'Uførerente URKN-60, 3mnd',
  URKN_60_SMOKER_KARENS_3_MONTHS = 'Uførerente URKN-60 med røyk, 3mnd karens',
  URKN_57 = 'Uførerente URKN-57',
  URKN_57_SMOKER = 'Uførerente URKN-57 med røyk',
  URKN_57_3MONTHS = 'Uførerente URKN-57, 3mnd',
  URKN_57_SMOKER_KARENS_3_MONTHS = 'Uførerente URKN-57 med røyk, 3mnd karens',
  MAN_UFR = 'Uførerente mann UFR',
  MAN_UFR_SMOKER = 'Uførerente mann UFR med røyk',
  MAN_UFR_3MONTHS = 'Uførerente mann UFR, 3mnd',
  MAN_UFR_SMOKER_KARENS_3_MONTHS = 'Uførerente mann UFR med røyk, 3mnd karens',
  WOMAN_UFR = 'Uførerente kvinne UFR',
  WOMAN_UFR_SMOKER = 'Uførerente kvinne UFR med røyk',
  WOMAN_UFR_3MONTHS = 'Uførerente kvinne UFR, 3mnd',
  WOMAN_UFR_SMOKER_KARENS_3_MONTHS = 'Uførerente kvinne UFR med røyk, 3mnd karens',
  ADMIN = 'Admindekning',
  ADMIN_NO_PIECE_RATE = 'Admindekning - uten stykk',
}

export enum AuroraDisabilityTotalCoverage {
  TOTAL_UTKN = 'Uførhet Total UTKN',
  TOTAL_UTKN_SMOKER = 'Uførhet Total UTKN med røyk',
  TOTAL_UTKN_ADMIN = 'Admindekning UTKN',
  TOTAL_UTKN_ADMIN_NO_PIECE_RATE = 'Admindekning UTKN - uten stykk',
  TOTAL_UKFK_MAN = 'Uførhet Total mann UKFK-M',
  TOTAL_UKFK_MAN_SMOKER = 'Uførhet Total mann UKFK med røyk',
  TOTAL_UKFK_WOMAN = 'Uførhet Total kvinne UKFK-K',
  TOTAL_UKFK_WOMAN_SMOKER = 'Uførhet Total kvinne UKFK med røyk',
  TOTAL_UKFK_ADMIN = 'Admindekning UKFK',
  TOTAL_UKFK_ADMIN_NO_PIECE_RATE = 'Admindekning UKFK - uten stykk',
  BASIS_UKFB_MAN = 'Uførhet Basis mann UKFB-M',
  BASIS_UKFB_MAN_SMOKER = 'Uførhet Basis mann UKFB med røyk',
  BASIS_UKFB_WOMAN = 'Uførhet Basis kvinne UKFB-K',
  BASIS_UKFB_WOMAN_SMOKER = 'Uførhet Basis kvinne UKFB med røyk',
  BASIS_UKFB_ADMIN = 'Admindekning UKFB',
  BASIS_UKFB_ADMIN_NO_PIECE_RATE = 'Admindekning UKFB - uten stykk',
  INCAPACITY_OF_WORK_UKF_MAN = 'Arbeidsuførhet mann UKF',
  INCAPACITY_OF_WORK_UKF_MAN_SMOKER = 'Arbeidsuførhet mann UKF med røyk',
  INCAPACITY_OF_WORK_UKF_WOMAN = 'Arbeidsuførhet kvinne UKF-K',
  INCAPACITY_OF_WORK_UKF_WOMAN_SMOKER = 'Arbeidsuførhet kvinne UKF med røyk',
  INCAPACITY_OF_WORK_UKF_ADMIN = 'Admindekning UKF',
  INCAPACITY_OF_WORK_UKF_ADMIN_NO_PIECE_RATE = 'Admindekning UKF - uten stykk',
}

export enum BoatCoverage {
  ROWBOAT_CANOE_KAYAK_FULL_OWN_DAMAGE = 'Kasko',
  ROWBOAT_CANOE_KAYAK_REDUCED_OWN_DAMAGE = 'Delkasko inkl. ansvar, fører og passasjerulykke',
  INBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED = 'Kasko med utvidet dekning',
  INBOARD_MOTOR_FULL_OWN_DAMAGE = 'Kasko',
  INBOARD_MOTOR_REDUCED_OWN_DAMAGE = 'Delkasko inkl. ansvar, fører og passasjerulykke',
  OUTBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED = 'Kasko med utvidet dekning',
  OUTBOARD_MOTOR_FULL_OWN_DAMAGE = 'Kasko',
  OUTBOARD_MOTOR_REDUCED_OWN_DAMAGE = 'Delkasko inkl. ansvar, fører og passasjerulykke',
  SAILING_BOAT_FULL_OWN_DAMAGE_EXTENDED = 'Kasko med utvidet dekning',
  SAILING_BOAT_FULL_OWN_DAMAGE = 'Kasko',
  SAILING_BOAT_REDUCED_OWN_DAMAGE = 'Delkasko inkl. ansvar, fører og passasjerulykke',
  MOTOR_FULL_OWN_DAMAGE_EXTENDED = 'Kasko med utvidet dekning',
  MOTOR_FULL_OWN_DAMAGE = 'Kasko',
  MOTOR_REDUCED_OWN_DAMAGE = 'Delkasko inkl. ansvar, fører og passasjerulykke',
  JETSKI_FULL_OWN_DAMAGE = 'Kasko',
  JETSKI_REDUCED_OWN_DAMAGE = 'Delkasko inkl. ansvar',
}

export enum CabinCoverage {
  FIRE = 'brann- og naturskade',
  STANDARD = 'standard',
  SUPER = 'super',
}

export enum CabinContentsCoverage {
  STANDARD = 'Standard Innbo og løsøre',
  EXTENDED = 'Super Innbo og løsøre med utvidet dekning',
  NATURE = 'Naturskade',
}

/**
 * The INVALID_COVERAGE is not a valid Car coverage.
 * Some insurances created manually in F2100 may miss the coverage property, and we have logic to check for this.
 * The value should only be used in this logic.
 */
export enum CarCoverage {
  ACCIDENT = 'accident',
  REDUCED_OWN_DAMAGE = 'delkasko',
  FULL_OWN_DAMAGE = 'kasko',
  FULL_OWN_DAMAGE_INCLUDING_RENTALCAR = 'Kasko med leiebil',
  FULL_SUPER_V2 = 'super new',
  FULL_SUPER = 'super old',

  INVALID_COVERAGE = 'Ingen',
}

export enum CaravanCoverage {
  FIRE_AND_THEFT = 'Brann og tyveri',
  FULL_OWN_DAMAGE = 'Kasko',
  FULL_OWN_DAMAGE_EXTENDED_MOVABLES_1 = 'Kasko med utvidet løsøresum til 30.000',
  FULL_OWN_DAMAGE_EXTENDED_MOVABLES_2 = 'Kasko med utvidet løsøresum til 50.000',
  FULL_OWN_DAMAGE_EXTENDED_MOVABLES_3 = 'Kasko med utvidet løsøresum til 100.000',
  FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE = 'Kasko, fast sted',
  FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_1 = 'Kasko, fast sted, med utvidet løsøresum til 30.000',
  FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_2 = 'Kasko, fast sted, med utvidet løsøresum til 50.000',
  FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_3 = 'Kasko, fast sted, med utvidet løsøresum til 100.000',
  SUPER = 'Super',
  MORTGAGEE = 'Panthaver',
}

export enum ChildCoverage {
  STANDARD = 'Standard',
  UPGRADED_PLUS = 'Utvidet',
  EXTENDED = 'Utvided',
  PLUS = 'Pluss',
  UPGRADED_TOP = 'Super',
  SUPER = 'Super',
  TOP = 'Topp',
}

export enum CriticalIllnessCoverage {
  NOT_SMOKER = 'Kritisk sykdom - Ikke røyker',
  SMOKER = 'Kritisk sykdom - Røyker',
  CLEAN = 'Kritisk sykdom',
}

export enum DeathCoverage {
  NOT_SMOKER = 'Død - ikke røyker',
  SMOKER = 'Død - røyker',
  CLEAN = 'Død',
}

export enum ElectricScooterCoverage {
  FULL_OWN_DAMAGE = 'Kasko',
  REDUCED_OWN_DAMAGE = 'Delkasko',
  LIABILITY = 'Ansvar',
  DRIVER_AND_PASSENGER_ACCIDENT = 'Fører- og passasjerulykke',
}

export enum HouseCoverage {
  FIRE = 'brann- og naturskade',
  STANDARD = 'standard',
  SUPER = 'super',
}

export enum HouseContentsCoverage {
  SUPER = 'super',
  STANDARD = 'standard',
}

export enum MopedCoverage {
  FULL_OWN_DAMAGE = 'Kasko',
  REDUCED_OWN_DAMAGE = 'Delkasko',
  DRIVER_AND_PASSENGER_ACCIDENT = 'Fører- og passasjerulykke',
  LIABILITY = 'Ansvar',
  MORTGAGEE = 'Panthaver',
}

/**
 * The INVALID_COVERAGE is not a valid Motorcycle coverage.
 * Some insurances created manually in F2100 may miss the coverage property, and we have logic to check for this.
 * The value should only be used in this logic.
 */
export enum VehicleCoverage {
  LIABILITY = 'Ansvar',
  REDUCED_OWN_DAMAGE = 'Delkasko',
  FULL_OWN_DAMAGE = 'Kasko',
  DRIVER_AND_PASSENGER_ACCIDENT = 'Fører- og passasjerulykke',
  MORTGAGEE = 'Panthaver',
  LIABILITY_DEREG = 'Ansvar avregistrert',
  DRIVER_AND_PASSENGER_ACCIDENT_DEREG = 'Fører- og passasjerulykke avregistrert',

  INVALID_COVERAGE = 'Ingen',
}

export enum NewChildCoverage {
  BASIS = 'Basis',
  EXTRA = 'Ekstra',
  TOTAL = 'Total',
}

export enum PregnantAndNewbornCoverage {
  PREGNANT = 'Gravid',
  PREGNANT_MULTIPLE_CHILDREN = 'Gravid, flere barn',
  NEWBORN = 'Nyfødt',
  NEWBORN_MULTIPLE_CHILDREN = 'Nyfødt, flere barn',
}

export enum RentalCoverage {
  STANDARD = 'Utleie',
}

export enum TractorCoverage {
  LIABILITY = 'Ansvar',
  DRIVER_AND_PASSENGER_ACCIDENT = 'Fører- og passasjerulykke',
  FIRE_AND_THEFT = 'Brann og tyveri',
  FULL_OWN_DAMAGE = 'Kasko',
  MORTGAGEE = 'Panthaver',
}

export enum TrailerCoverage {
  FULL_OWN_DAMAGE = 'Kasko',
  FIRE_AND_THEFT = 'Brann og tyveri',
}

export enum TravelCoverage {
  STANDARD = 'Standard familiedekning med 45 dager reiselengde',
  SUPER_75_DAYS = 'Super familiedekning med 75 dager reiselengde',
  SUPER_90_DAYS = 'Super familiedekning med 90 dager reiselengde',
  SUPER_120_DAYS = 'Super familiedekning med 120 dager reiselengde',
  COVERAGE_FOR_INSURED_ONLY = 'Standard enkeltpersonsdekning med 45 dager reiselengde',
  SUPER_COVERAGE_FOR_INSURED_ONLY = 'Super enkeltpersonsdekning med 75 dager reiselengde',
  SUPER_COVERAGE_FOR_INSURED_ONLY_90_DAYS = 'Super enkeltpersonsdekning med 90 dager reiselengde',
  SUPER_COVERAGE_FOR_INSURED_ONLY_120_DAYS = 'Super enkeltpersonsdekning med 120 dager reiselengde',
}

export enum ValuablesCoverage {
  VALUABLE_VALUE = 'Verdisaksdekning',
}

export enum VeteranCoverage {
  FULL_OWN_DAMAGE = 'Kasko',
  REDUCED_OWN_DAMAGE = 'Delkasko',
  DRIVER_AND_PASSENGER_ACCIDENT = 'Fører- og passasjerulykke',
  LIABILITY = 'Ansvar',
  FIRE_AND_THEFT = 'Brann og Tyveri',
}

// NOTE: mapped from CoverageProduct in lisa-services-api
export enum HouseCoverageProduct {
  HOUSE_EXTENDED = 'HOUSE_EXTENDED', // 783
  HOUSE_EXTENDED_WITH_CRAWL_SPACE = 'HOUSE_EXTENDED_WITH_CRAWL_SPACE', // 783
  HOUSE_NATURE = 'HOUSE_NATURE', // 784
  HOUSE_OTHER_BUILDINGS_EXTENDED = 'HOUSE_OTHER_BUILDINGS_EXTENDED', // 786
  HOUSE_OTHER_BUILDINGS_STANDARD = 'HOUSE_OTHER_BUILDINGS_STANDARD', // 785
  HOUSE_STANDARD = 'HOUSE_STANDARD', // productNumber: 782
  HOUSE_STANDARD_WITH_PARTIALLY_RENTAL = 'HOUSE_STANDARD_WITH_PARTIALLY_RENTAL', // 782
  HOUSE_STANDARD_WITH_RENTAL = 'HOUSE_STANDARD_WITH_RENTAL', // 782
}

export enum CabinCoverageProduct {
  CABIN_EXTENDED = 'CABIN_EXTENDED', // 788
  CABIN_EXTENDED_RENTAL = 'CABIN_EXTENDED_RENTAL', // 788
  CABIN_EXTENDED_WITH_CRAWLSPACE = 'CABIN_EXTENDED_WITH_CRAWLSPACE', // 788
  CABIN_EXTENDED_WITH_CRAWLSPACE_RENTAL = 'CABIN_EXTENDED_WITH_CRAWLSPACE_RENTAL', // 788
  CABIN_EXTENDED_WITHOUT_CRAWLSPACE_RENTAL = 'CABIN_EXTENDED_WITHOUT_CRAWLSPACE_RENTAL', // 788
  CABIN_OTHER_BUILDINGS_EXTENDED = 'CABIN_OTHER_BUILDINGS_EXTENDED', // 788
  CABIN_OTHER_BUILDINGS_STANDARD = 'CABIN_OTHER_BUILDINGS_STANDARD', // 788
  CABIN_STANDARD = 'CABIN_STANDARD', // 788
}

export enum BoatCoverageProduct {
  BOAT_INBOARD_MOTOR_FULL_OWN_DAMAGE = 'BOAT_INBOARD_MOTOR_FULL_OWN_DAMAGE',
  BOAT_INBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED = 'BOAT_INBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED',
  BOAT_JETSKI_FULL_OWN_DAMAGE = 'BOAT_JETSKI_FULL_OWN_DAMAGE',
  BOAT_MOTOR_FULL_OWN_DAMAGE = 'BOAT_MOTOR_FULL_OWN_DAMAGE',
  BOAT_MOTOR_FULL_OWN_DAMAGE_EXTENDED = 'BOAT_MOTOR_FULL_OWN_DAMAGE_EXTENDED',
  BOAT_OUTBOARD_MOTOR_FULL_OWN_DAMAGE = 'BOAT_OUTBOARD_MOTOR_FULL_OWN_DAMAGE',
  BOAT_OUTBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED = 'BOAT_OUTBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED',
  BOAT_ROWBOAT_CANOE_KAYAK_FULL_OWN_DAMAGE = 'BOAT_ROWBOAT_CANOE_KAYAK_FULL_OWN_DAMAGE',
  BOAT_SAILING_BOAT_FULL_OWN_DAMAGE = 'BOAT_SAILING_BOAT_FULL_OWN_DAMAGE',
  BOAT_SAILING_BOAT_FULL_OWN_DAMAGE_EXTENDED = 'BOAT_SAILING_BOAT_FULL_OWN_DAMAGE_EXTENDED',
}

export enum CarCoverageProduct {
  CAR_FULL_OWN_DAMAGE = 'AUTO_FULL_OWN_DAMAGE',
  CAR_FULL_OWN_DAMAGE_INCLUDING_RENTALCAR = 'AUTO_FULL_OWN_DAMAGE_INCLUDING_RENTALCAR',
}

export enum CaravanCoverageProduct {
  CARAVAN_FULL_OWN_DAMAGE = 'CARAVAN_FULL_OWN_DAMAGE',
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_1 = 'CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_1',
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_2 = 'CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_2',
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_3 = 'CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_3',
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE = 'CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE',
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_1 = 'CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_1',
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_2 = 'CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_2',
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_3 = 'CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_3',
}

export enum NotSupportedCoverageProduct {
  NOT_SUPPORTED = 'NOT_SUPPORTED',
}

export enum NewChildCoverageProduct {
  NEWCHILD_DISABILITY_PENSION_HALF_G = 'NEWCHILD_DISABILITY_PENSION_HALF_G',
  NEWCHILD_MEDICAL_DISABILITY_ACCIDENT = 'NEWCHILD_MEDICAL_DISABILITY_ACCIDENT',
  NEWCHILD_MEDICAL_DISABILITY_DISEASE = 'NEWCHILD_MEDICAL_DISABILITY_DISEASE',
  NEWCHILD_ACCIDENT_TREATMENT_COST = 'NEWCHILD_ACCIDENT_TREATMENT_COST',
  NEWCHILD_DEATH_INSURANCE = 'NEWCHILD_DEATH_INSURANCE',
  NEWCHILD_SELECTED_DISEASES = 'NEWCHILD_SELECTED_DISEASES',
  NEWCHILD_HOSPITAL_STAYS = 'NEWCHILD_HOSPITAL_STAYS',
  NEWCHILD_DISABILITY_CAPITAL = 'NEWCHILD_DISABILITY_CAPITAL',
  NEWCHILD_DISABILITY_PENSION = 'NEWCHILD_DISABILITY_PENSION',
  NEWCHILD_REMODELING_OF_HOUSING = 'NEWCHILD_REMODELING_OF_HOUSING',
  NEWCHILD_OWNS_VIDEO_CONSULTATION_GENERAL_PRACTITIONER = 'NEWCHILD_OWNS_VIDEO_CONSULTATION_GENERAL_PRACTITIONER',
  NEWCHILD_CARING_AND_CARE = 'NEWCHILD_CARING_AND_CARE',
  NEWCHILD_TREATMENT_INSURANCE = 'NEWCHILD_TREATMENT_INSURANCE',
}

export enum MotorcycleCoverageProduct {
  MOTORCYCLE_FULL_OWN_DAMAGE = 'MOTORCYCLE_FULL_OWN_DAMAGE',
  MOTORCYCLE_REDUCED_OWN_DAMAGE = 'MOTORCYCLE_REDUCED_OWN_DAMAGE',
  MOTORCYCLE_DRIVER_AND_PASSENGER_ACCIDENT = 'MOTORCYCLE_DRIVER_AND_PASSENGER_ACCIDENT',
  MOTORCYCLE_LIABILITY = 'MOTORCYCLE_LIABILITY',
  MOTORCYCLE_MORTGAGEE = 'MOTORCYCLE_MORTGAGEE',
  MOTORCYCLE_LIABILITY_DEREG = 'MOTORCYCLE_LIABILITY_DEREG',
  MOTORCYCLE_DRIVER_AND_PASSENGER_ACCIDENT_DEREG = 'MOTORCYCLE_DRIVER_AND_PASSENGER_ACCIDENT_DEREG',
}
